import { render, staticRenderFns } from "./resultado.vue?vue&type=template&id=02faf814&scoped=true&"
import script from "./resultado.vue?vue&type=script&lang=js&"
export * from "./resultado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02faf814",
  null
  
)

export default component.exports